export const ALL = "all"

export const pulseSurveyTabIds = {
    "CreateSurveyNotification": "create-survey-notification",
    "CurrentSurveyNotifications": "current-survey-notifications"
}

export const DisplayOptions = {
    EVERYWHERE: "everywhere",
    CLOSE_PORTAL: "close-portal",
    APP: "app-pages",
    URL_PREFIX: "url-prefix",
    TRIGGER: "trigger"
}

export const displayOptions = [
    { label: "Everywhere", value: DisplayOptions.EVERYWHERE },
    { label: "Close Portal Pages", value: DisplayOptions.CLOSE_PORTAL },
    { label: "At Given Url Prefixes", value: DisplayOptions.URL_PREFIX },
    { label: "App Pages", value: DisplayOptions.APP },
]

// Trigger display option is not user-selectable; it is auto-set when an action trigger is configured
export const triggerDisplayOption = { label: "Trigger (Action-based)", value: DisplayOptions.TRIGGER };

export const notificationDisplayTypes = [
    // value is of type FlashbarProps.Type (same as banner types)
    { label: "Critical", value: "error" },
    { label: "Warning", value: "warning" },
    { label: "Info", value: "info" },
    { label: "Success", value: "success" },
];

export const ActionTriggerOptions = {
    NONE: "none",
    PUBLISH: "publish",
    EXECUTE: "execute",
    SUBMIT: "submit"
}

export const actionTriggerOptions = [
    { label: "None", value: ActionTriggerOptions.NONE },
    { label: "Publish (AI App)", value: ActionTriggerOptions.PUBLISH },
    { label: "Execute (FLEXICO)", value: ActionTriggerOptions.EXECUTE },
    { label: "Submit (FRISCO)", value: ActionTriggerOptions.SUBMIT },
]

export const AutoPopupDelayTypes = {
    NONE: "none",
    TIME_ON_PAGE: "time-on-page",
    SESSION_TIME: "session-time"
}

export const autoPopupDelayTypeOptions = [
    { label: "None (Immediate)", value: AutoPopupDelayTypes.NONE },
    { label: "Time on Page/Path (seconds)", value: AutoPopupDelayTypes.TIME_ON_PAGE },
    { label: "Session Time (total time on website)", value: AutoPopupDelayTypes.SESSION_TIME },
]
